import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "footer-item";
export var FOOTER_ITEM_CONSTANTS = {
    elementName: elementName,
};
